import uniqBy from 'lodash/uniqBy'
import find from 'lodash/find'

import { BraintreePaymentComponent } from '../Features/PaymentMethod'
import { TranslationUtility } from '../../util/translationUtility';

// https://lodash.com/docs/4.17.10#uniqBy
const isAllUniqueValues = (list, iteratee = x => x) => {
  const len = list.length;
  const uniqLength = uniqBy(list, iteratee).length;
  return len === uniqLength;
}


//const addressesAreInvalid = (addresses) => {
//  if (!isAllUniqueValues(addresses.map(address => address.Id))) {
//    console.error('not all Ids unique for ShippingAddresses and BillingAddresses');
//    return true;
//  }
//}

const shippingOptionsAreInvalid = (shippingOptions) => {
  if (!isAllUniqueValues(shippingOptions, so => so.Id)) {
    console.error('not all Ids unique for ShippingOptions');
    return true;
  }
}

const paymentOptionsAreInvalid = (paymentOptions) => {
  if (!isAllUniqueValues(paymentOptions, po => po.Id)) {
    console.error('not all Ids unique for PaymentOptions');
    return true;
  }
}

const cartItemsAreInvalid =(cartItems) => {
  if (!isAllUniqueValues(cartItems, ci => ci.Id)) {
    console.error('not all Ids unique for CartItems');
    return true;
  }
}

// Perhaps https://validatejs.org/ would be useful here
const initialDataIsInvalid = (initialData) => {
  // BBS DDD 2018-03-07 Don't validate address id uniqueness. Addresses can be of multiple types
  //let addresses = initialData.BillingAddresses.concat(initialData.ShippingAddresses);
  //if (addressesAreInvalid(addresses)) {
  //  return true;
  //}
  if (shippingOptionsAreInvalid(initialData.ShippingOptions)) {
    return true;
  }
  if (paymentOptionsAreInvalid(initialData.PaymentOptions)) {
    return true;
  }
  if (cartItemsAreInvalid(initialData.CartItems)) {
    return true;
  }
}

const mapTopLevelPropsToInitialStoreState = props => {
  // validate
  if (initialDataIsInvalid(props.initialData)) {
    return {};
  }

  // Do some calculations for init
  let selectedShippingOption = props.initialData.ShippingOptions.filter(so => so.IsSelected)[0];
  if (!selectedShippingOption && props.initialData.ShippingOptions.length === 1) {
    selectedShippingOption = props.initialData.ShippingOptions[0];
  }

  // Add controls to payment if they have one
  const paymentOptions = props.initialData.PaymentOptions.map(po => {
    if (po.Id === props.BraintreeClientSettings.BraintreePaymentOptionId) {
      po.paymentOptionComponent = BraintreePaymentComponent;
    }
    return po;
  });

  let selectedPaymentOption = find(paymentOptions, po => po.IsSelected);
    if (!selectedPaymentOption) {        
            selectedPaymentOption = paymentOptions[0];        
    }

  const allowBillingEqualsShipping = props.initialData.AllowBillingEqualsShipping;
  const disableBillingChanges = props.initialData.DisableBillingChanges;
  const selectedShippingAddressId = props.initialData.SelectedShippingAddressId;
  const selectedBillingAddressId = allowBillingEqualsShipping && selectedShippingAddressId
    ? selectedShippingAddressId
    : props.initialData.SelectedBillingAddressId;

  const translationUtility = new TranslationUtility(props.localizationItems);
  let completeCheckoutButtonText = "";
  switch(props.initialData.OrderType) {
    case props.onlineOrderOrderType:
      completeCheckoutButtonText = translationUtility.translateResourceString('/Checkout/Index/Order/CheckoutButtonText');
      break;
    case props.onlineQuoteOrderType:
      completeCheckoutButtonText = translationUtility.translateResourceString('/Checkout/Index/Quote/CheckoutButtonText');
      break;
  }
  return {
    // BBS DDD 2017-11-19 The state of the ui. Make all ui updates here.
    ui: {
      PhoneNumber: props.initialData.PhoneNumber,
      PhoneText: props.initialData.PhoneText,
      useShippingForBilling: allowBillingEqualsShipping,
      disableBillingChanges: disableBillingChanges,
      messages: [],
      completeCheckoutButtonText: completeCheckoutButtonText,
      isPlaceOrderPending: false,
      isShippingPending: false,
      checkoutEnvironmentMessage: props.initialData.CheckoutEnvironmentMessage,
    },
    // BBS DDD 2017-11-19 The state of the checkout. Make all business
    // BBS WTB 2022-06-23 Added Has Restricted Items property.
    // updates here
    entities: {
      Addresses: props.initialData.BillingAddresses.concat(props.initialData.ShippingAddresses),
      BillingAddresses: props.initialData.BillingAddresses.map(addr => addr.Id),
      SelectedBillingAddressId: selectedBillingAddressId,
      ShippingAddresses: props.initialData.ShippingAddresses.map(addr => addr.Id),
      SelectedShippingAddressId: selectedShippingAddressId,
      CartItems: props.initialData.CartItems,
      OrderNumber: 0,
      PaymentOptions: paymentOptions,
      PONumber: '',
      SelectedPaymentOptionId: selectedPaymentOption ? selectedPaymentOption.Id : '',
      ShippingOptions: props.initialData.ShippingOptions,
      SelectedShippingOptionId: selectedShippingOption ? selectedShippingOption.Id : '',
      SubTotal: props.initialData.SubTotal,
      Summary: props.initialData.CheckoutSummary,
      PaymentRecord: {},
      CouponCode: props.initialData.CouponCode,
      AnonymousUserEmail: props.initialData.AnonymousUserEmail,
      OrderType: props.initialData.OrderType,
      HasRestrictedItems: props.initialData.HasRestrictedItems
    },
    // BBS DDD 2017-11-19 Data definitions and other things
    constants: {
      // Locations of server resources
      navigation: {
        MyAccountLink: '',
        checkoutUrl: props.checkoutUrl,
        ReceiptUrl: props.initialData.ReceiptUrl,
        addAddressEndpoint: props.addAddressEndpoint,
        deleteAddressEndpoint: props.deleteAddressEndpoint,
        cartSummaryEndpoint: props.cartSummaryEndpoint,
        braintreeClientTokenEndpoint: props.braintreeClientTokenEndpoint,
        placeOrderEndpoint: props.placeOrderEndpoint,
        orderConfirmationUrl: props.orderConfirmationUrl,
        updateItemQuantityEndpoint: props.updateQuantityEndpoint,
        deleteItemEndpoint: props.deleteItemEndpoint,
        getShippingMethodsEndpoint: props.getShippingMethodsEndpoint,
        updateSelectedAddressEndpoint: props.updateSelectedAddressEndpoint,
        fipsEndpoint: props.fipsEndpoint,
        addCouponEndpoint: props.addCouponEndpoint,
        removeCouponEndpoint: props.removeCouponEndpoint,
        couponEndpoint: props.couponEndpoint,
        updateAnonymousUserEmailEndpoint: props.updateAnonymousUserEmailEndpoint,
        removeAnonymousUserEmailEndpoint: props.removeAnonymousUserEmailEndpoint,
        getOrderTypeEndpoint: props.getOrderTypeEndpoint,
        setShippingMethodEndpoint: props.setShippingMethodEndpoint,
        getCartItemsEndpoint: props.getCartItemsEndpoint
      },
      ShippingAddressType: props.ShippingAddressType,
      BillingAddressType: props.BillingAddressType,
      countriesStatesMap: props.countriesStatesMap,
      countries: props.countries,
      braintreeSettings: {
        usePaypal: props.BraintreeClientSettings.BraintreePaypalEnabled,
        usePaypalCredit: props.BraintreeClientSettings.BraintreePaypalCreditEnabled,
        braintreePaypalFlow: props.BraintreeClientSettings.BraintreePaypalFlow,
        braintreePaymentId: props.BraintreeClientSettings.BraintreePaymentOptionId,
      },
      allowBillingEqualsShipping: props.initialData.allowBillingEqualsShipping,
      disableBillingChanges: props.initialData.disableBillingChanges,
      purchaseOrderPaymentId: props.purchaseOrderPaymentId,
      UserIsAnonymous: props.initialData.UserIsAnonymous,
      onlineOrderOrderType: props.onlineOrderOrderType,
      onlineQuoteOrderType: props.onlineQuoteOrderType,
      localizationItems: props.localizationItems,
      SiteKey: props.initialData.SiteKey
    }
  }
}


export default mapTopLevelPropsToInitialStoreState


// WEBPACK FOOTER //
// ./src/Components/checkout/GlobalStateContainer/mapTopLevelPropsToInitialStore.js